<template>
  <div>
    <v-range-slider
      label="Výber obdobia"
      v-model="dateRange"
      step="1"
      :min="minYear"
      :max="maxYear"
      ticks="always"
      tick-size="4"
      thumb-label="always"
    ></v-range-slider>
    <!-- mierka je natvrdo, ale vychadzam z toho, ze na kazdom zoome je ta mierka konstantna, dalsie info vid. https://wiki.openstreetmap.org/wiki/Zoom_levels -->
    <v-slider
      v-model="linesZoom"
      color="orange"
      label="Mierka posunov"
      min="20"
      max="30"
      :tick-labels="[
        '1:500',
        '1:250',
        '1:150',
        '1:70',
        '1:35',
        '1:15',
        '1:8',
        '1:4',
        '1:2',
        '1:1',
        '1:0.5',
      ]"
      ticks="always"
      tick-size="4"
    ></v-slider>
    <l-map
      :zoom="zoom"
      :center="center"
      style="height: 600px; width: 100%; z-index: 0"
      ref="map"
      :bounds="bounds"
      @ready="setMapView"
      @update:zoom="zoomUpdated"
    >
      <l-tile-layer :url="url"></l-tile-layer>
      <l-control-scale
        position="topright"
        :imperial="false"
        :metric="true"
      ></l-control-scale>
      <l-control position="bottomright">
        <v-img :src="require('../assets/nautical.svg')"></v-img>
      </l-control>
      <l-control position="bottomleft" v-if="isPublic">
        <v-img :src="require('../assets/logo_SGUDS_cb.svg')"></v-img>
      </l-control>
      <l-control-layers position="topright"></l-control-layers>
      <l-tile-layer
        v-for="tileProvider in tileProviders"
        :key="tileProvider.name"
        :name="tileProvider.name"
        :visible="tileProvider.visible"
        :url="tileProvider.url"
        :attribution="tileProvider.attribution"
        layer-type="base"
      />
      <template v-if="body.length > 0">
        <template v-for="(bod, i) in body">
          <l-circle-marker
            :key="`marker-${bod.ID}`"
            v-if="bod.Lat != 0 && bod.Lng != 0"
            :lat-lng="[bod.Lat, bod.Lng]"
            :radius="5"
          >
            <l-tooltip>{{ bod.ZNMB }}</l-tooltip>
          </l-circle-marker>
          <l-polyline
            :key="`polyline-${bod.ID}`"
            :ref="`polyline-${bod.ID}`"
            :lat-lngs="scaledLatLngs[i]"
            color="red"
            @ready="polylineReady(`polyline-${bod.ID}`)"
          ></l-polyline>
          <l-circle-marker
            v-for="(posun, posunI) in filterMerGeos(bod.MerGeos)"
            :key="`markerPosun-${bod.ID}-${posunI}`"
            :lat-lng="scaledLatLngs[i][posunI]"
            :radius="2"
            :weight="1"
            color="red"
          >
            <l-tooltip :options="{ permanent: false, opacity: 0.7 }">
              <div style="font-size: 7pt">
                <b>{{ posunI + 1 }})</b>
                {{ getPosunString(posun) }}
              </div>
            </l-tooltip>
          </l-circle-marker>
        </template>
      </template>
    </l-map>
    <scatter-chart
      v-if="Object.keys(grafOptions).length > 0"
      :chart-data="grafValues"
      :options="grafOptions"
    ></scatter-chart>
  </div>
</template>

<script>
//import * as L from "leaflet"
import ScatterChart from "../components/charts/ScatterChart.js"
import {
  LMap,
  LControl,
  LControlScale,
  LControlLayers,
  LTileLayer,
  LCircleMarker,
  LPolyline,
  LTooltip
} from "vue2-leaflet"
import moment from "moment"
import "leaflet-arrowheads"

export default {
  components: {
    ScatterChart,
    LMap,
    LControl,
    LControlScale,
    LControlLayers,
    LTileLayer,
    LCircleMarker,
    LPolyline,
    LTooltip
  },

  props: {
    body: {
      type: Array,
      required: true,
      default: function() {
        return []
      }
    },
    bounds: {
      type: Array,
      required: false
    }
  },

  data: () => ({
    mapOptions: {
      zoomSnap: 0.5
    },
    zoom: 8,
    center: [48.6, 19.7],
    url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",

    linesZoom: 20,
    scaledLatLngs: [],
    dateRange: [],
    grafValues: {},
    grafOptions: {},
    tileProviders: [
      {
        name: "OpenTopoMap",
        visible: false,
        attribution:
          'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
        url: "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
      },
      {
        name: "FreeMapSk",
        visible: true,
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, vizualization CC-By-SA 2.0 <a href="http://freemap.sk">Freemap.sk</a>',
        url: "https://{s}.freemap.sk/T/{z}/{x}/{y}.jpeg"
      },
      {
        name: "ZBGIS",
        visible: true,
        attribution:
          '&copy; <a target="_blank" href="https://zbgis.skgeodesy.sk/">ZBGIS</a>',
        url:
          "https://zbgis.skgeodesy.sk/zbgis/rest/services/ZBGIS/MapServer/tile/{z}/{y}/{x}"
      },
      {
        name: "OpenStreetMap",
        visible: true,
        attribution:
          '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      }
    ]
  }),

  computed: {
    isPublic: function() {
      let ret = false
      if (window.location.href.indexOf("public") > 0) {
        ret = true
      }
      return ret
    },
    minYear: function() {
      if (this.body.length > 0) {
        if (this.body[0].MerGeos.length > 0) {
          return moment(this.body[0].MerGeos[0].Datum).year()
        }
      }
      return moment().year()
    },
    maxYear: function() {
      if (this.body.length > 0) {
        if (this.body[0].MerGeos.length > 0) {
          return (
            moment(
              this.body[0].MerGeos[0][this.body[0].MerGeos.length - 1]
            ).year() + 1
          )
        }
      }
      return moment().year() + 1
    }
  },

  watch: {
    linesZoom: function() {
      this.scaledLatLngs = this.rescaleLatLngs()
    },
    body: {
      deep: true,
      handler() {
        this.dateRange = [this.minYear, this.maxYear]
        this.scaledLatLngs = this.rescaleLatLngs()
      }
    },
    dateRange: function() {
      this.scaledLatLngs = this.rescaleLatLngs()
      this.showGraf()
    }
  },

  methods: {
    getPosunString: function(aPosun) {
      let ret = ""
      //console.log("aPosun", aPosun)
      //moment.locale("sk")
      ret = moment(aPosun.Datum, "YYYY-MM-DDTHH:mm:ssZ").format("MMM YYYY")
      ret += " - " + aPosun.distance + " mm"
      return ret
    },
    showGraf: function() {
      if (this.body.length > 1) {
        return false
      }
      let filteredMerGeos = this.filterMerGeos(this.body[0].MerGeos)
      this.grafValues = {
        datasets: [
          {
            label: "Poloha",
            data: filteredMerGeos.map(function(i) {
              return { x: i.X, y: i.Y }
            }),
            backgroundColor: "#ff0000",
            borderColor: "#ff0000",
            pointRadius: "1",
            borderWidth: "1",
            pointStyle: "circle",
            showLine: true,
            lineTension: 0,
            fill: "false"
          }
        ]
      }
      this.grafOptions = {
        maintainAspectRatio: false,
        responsive: false,
        title: {
          display: true,
          text: `Zobrazenie vývoja pohybovej aktivity na bode za obdobie (${this.dateRange[0]} - ${this.dateRange[1]})`
        },
        legend: { display: true, position: "top" },
        scales: {
          xAxes: [
            {
              display: true,
              position: "top",
              scaleLabel: {
                display: true,
                labelString: "X"
              }
            }
          ],
          yAxes: [
            {
              display: true,
              position: "right",
              scaleLabel: {
                display: true,
                labelString: "Y"
              }
            }
          ]
        }
      }
    },
    filterMerGeos: function(merGeos) {
      let merGeosFiltered = merGeos.filter(
        i =>
          moment(i.Datum).isAfter(moment([this.dateRange[0]])) &&
          moment(i.Datum).isBefore(moment([this.dateRange[1]]))
      )
      for (let j = 0; j < merGeosFiltered.length; j++) {
        const ll = merGeosFiltered[j]
        ll.distance = this.getDistance(merGeosFiltered[0], ll)
      }
      //console.log("merGeosFiltered", merGeosFiltered)
      return merGeosFiltered
      /*
      for (let i = 0; i < latlngs.length; i++) {
        const latlang = latlngs[i]
        console.log("latlang " + i, latlang)
        for (let j = 0; j < latlang.length; j++) {
          const ll = latlang[j]
          ll.distance = this.getDistance(latlang[0], ll)
          console.log("ll " + j, ll)
        }
      }
      console.log("latlngs", latlngs)
      */
    },
    rescaleLatLngs: function() {
      if (!this.$refs.map) {
        return []
      }
      var map = this.$refs.map.mapObject
      let latlngs = this.body.map(b => {
        var merania = Array.from(this.filterMerGeos(b.MerGeos))
        if (merania.length <= 1) {
          return []
        }
        var start = merania.shift() // zoberieme prve meranie v casovom rade
        var startPoint = map.project(
          [start.VypLat, start.VypLng],
          this.linesZoom
        ) // ziskame pixel koordinaty bodu pre dany zoom (je to zoom posunov, nie mapy!)
        var latlngs = merania.map(m => {
          var point = map.project([m.VypLat, m.VypLng], this.linesZoom) // ziskame pixel koordinaty bodu pre dany zoom
          // koordinaty prepocitaneho bodu ziskame tak, ze najprv zistime rozdiel koordinatov medzi aktualnym bodom a prvym bodom na zoome posunov,
          // potom pripocitame naspat k prvemu bodu na zoome mapy
          var pointScaled = map
            .project([start.VypLat, start.VypLng], this.zoom)
            .add(point.subtract(startPoint))
          return map.unproject(pointScaled, this.zoom) // nakoniec vratime lat a lng pre prepocitany bod pre dany zoom mapy
        })
        latlngs.unshift({ lat: start.VypLat, lng: start.VypLng })
        return latlngs
      })
      return latlngs
    },

    setMapView: function() {
      this.scaledLatLngs = this.rescaleLatLngs()
      this.$nextTick(() => {
        if (this.body.length > 0) {
          this.$refs.map.mapObject.setView(
            [this.body[0].Lat, this.body[0].Lng],
            12
          )
        }
      })
    },

    zoomUpdated(zoom) {
      this.zoom = zoom
      this.scaledLatLngs = this.rescaleLatLngs()
    },

    polylineReady: function(obj) {
      let refObj = this.$refs[obj]
      refObj[0].mapObject.arrowheads({
        size: "25%",
        frequency: "endonly",
        proportionalToTotal: false,
        yawn: 60,
        fill: false
      })
    },

    getDistance: function(ll0, ll1) {
      //console.log("getDistance", ll0, ll1)
      const xD = ll1.X - ll0.X
      const yD = ll1.Y - ll0.Y
      const d = Math.sqrt(Math.pow(xD, 2) + Math.pow(yD, 2)) * 1000
      return d.toFixed(2)
    }
  },
  mounted: function() {
    this.dateRange = [this.minYear, this.maxYear]
  }
}
</script>
